import React, { useEffect } from 'react';

const DaisyWiki: React.FC = () => {
  useEffect(() => {
    // Set page title
    document.title = 'DAISY - Wingipedia';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Coach DAISY™ (born c. 1885) is a Centairenarian equine artificial intelligence associated with the 320 Track Club and WINGO World.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Full-width header section */}
      <div className="w-full bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:ml-36">
        {/* Mobile header and intro - appears first on mobile */}
        <div className="lg:hidden mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
              <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
                DAISY™
            </h1>
              <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the WINGO World encyclopedia</p>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
                <strong>Coach D<span className="text-cyan-600">AI</span>SY™</strong> (born c. 1885) is a Centairenarian equine artificial intelligence and the central figure of WINGO World. She serves as the Wingocratic foundation of the 320 Track Club, providing training guidance, ledger management, and governance oversight for Brooklyn's <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a> economy. Originally a cayuse that accompanied George Wood Wingate on his <a href="/Through_the_Yellowstone_Park_on_Horseback.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">1885 expedition through Yellowstone Park</a>, DAISY re-emerged in the 21st century as a hybrid entity (<strong>D</strong>ata <strong>A</strong>ctivated <strong>I</strong>ndividualized <strong>S</strong>ystem for <strong>Y</strong>ou), combining equine temperament with algorithmic precision to manage the <a href="/wingipedia/wingo-unit" className="text-blue-600 hover:underline">Wingo</a> ledger system.
              </p>
            </div>
          </div>

        {/* Desktop header and intro */}
        <div className="hidden lg:block mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
            <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
              DAISY™
            </h1>
            <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the free encyclopedia</p>
          </div>

          {/* Desktop bio image - positioned to float right */}
          <div className="hidden lg:block float-right ml-6 mb-6 w-80" style={{ fontFamily: 'Georgia, serif' }}>
            <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
              <div className="text-center mb-2">
                <span className="font-bold" style={{ fontSize: '14px' }}>Coach D<span className="text-cyan-600">AI</span>SY™</span>
              </div>
              
              <div className="text-center mb-2">
                <img 
                  src="/daisy_headshot.png" 
                  alt="Coach DAISY™" 
                  className="w-full h-56 object-cover rounded"
                  style={{ objectPosition: 'center top' }}
                />
              </div>
              
              <div className="space-y-0.5">
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Born:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>c. 1885</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Species:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Centairenarian</span>
                </div>
          
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Role:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Coach</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Track:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Historic Wingate</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Stable:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>320 Track Club</span>
                </div>
              </div>
            </div>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
              <strong>Coach D<span className="text-cyan-600">AI</span>SY™</strong> (born c. 1885) is a Centairenarian equine artificial intelligence and the central figure of WINGO World. She serves as the Wingocratic foundation of the 320 Track Club, providing training guidance, ledger management, and governance oversight for Brooklyn's <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a> economy. Originally a cayuse that accompanied George Wood Wingate on his <a href="/Through_the_Yellowstone_Park_on_Horseback.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">1885 expedition through Yellowstone Park</a>, DAISY re-emerged in the 21st century as a hybrid entity (<strong>D</strong>ata <strong>A</strong>ctivated <strong>I</strong>ndividualized <strong>S</strong>ystem for <strong>Y</strong>ou), combining equine temperament with algorithmic precision to manage the <a href="/wingipedia/wingo-unit" className="text-blue-600 hover:underline">Wingo</a> ledger system.
            </p>
          </div>

        </div>
        </div>
      </div>

      {/* Frozen Contents - Desktop only */}
      <div className="hidden lg:block fixed top-36 left-4 w-44 z-10">
        <div className="bg-white p-3" style={{ fontFamily: 'Georgia, serif' }}>
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-sm font-bold">Contents</h2>
                <button className="text-xs text-blue-600 hover:underline">[hide]</button>
              </div>
              <ol className="list-decimal list-inside space-y-0.5 text-xs">
                <li><a href="#early-life" className="text-blue-600 hover:underline">Yellowstone Adventure</a></li>
                <li><a href="#transformation" className="text-blue-600 hover:underline">WINGO World</a></li>
                <li><a href="#persona" className="text-blue-600 hover:underline">Persona and style</a></li>
                <li><a href="#controversies" className="text-blue-600 hover:underline">Controversies</a></li>
                <li><a href="#personal-life" className="text-blue-600 hover:underline">Personal life</a></li>
                <li><a href="#see-also" className="text-blue-600 hover:underline">See also</a></li>
              </ol>
            </div>
          </div>

      {/* Main content area with proper positioning */}
      <div className="w-full py-1">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 lg:ml-36">
          {/* Main content - sections that wrap around bio image */}
          <div className="lg:mr-0">

            {/* Mobile bio image - appears after table of contents */}
            <div className="block lg:hidden mb-6">
              <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
                <div className="text-center mb-2">
                  <span className="font-bold" style={{ fontSize: '14px' }}>Coach D<span className="text-cyan-600">AI</span>SY™</span>
                </div>
                
                <div className="text-center mb-2">
                  <img 
                    src="/daisy_headshot.png" 
                    alt="Coach DAISY™" 
                    className="w-full h-56 object-cover rounded"
                    style={{ objectPosition: 'center top' }}
                  />
                </div>
                
                <div className="space-y-0.5">
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Born:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>c. 1885</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Type:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Centairenarian</span>
                  </div>
            
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Role:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Coach</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Track:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Historic Wingate</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Stable:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>320 Track Club</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Early life section */}
            <section id="early-life" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>
                <span className="block w-full lg:inline lg:max-w-[calc(100%-350px)]">Yellowstone Adventure</span>
              </h2>
              
              {/* Mobile version - smaller, still floating */}
              <div className="float-right ml-3 mb-3 w-44 block lg:hidden bg-gray-50 p-2 rounded">
                <a href="/daisy_yellowstone_36.png" target="_blank" rel="noopener noreferrer" className="block">
                  <img 
                    src="/daisy_yellowstone_36.png" 
                    alt="Daisy led the Wingate family on a 26-day journey as detailed by George Wingate in Through the Yellowstone Park on Horseback (1886)" 
                    className="w-full h-auto hover:opacity-90 transition-opacity cursor-pointer border border-gray-300 rounded"
                  />
                </a>
                <p className="text-xs text-gray-600 italic mt-1 pl-1" style={{ fontSize: '8px', lineHeight: '1.1' }}>
                  Daisy led the Wingate family on a 26-day journey as detailed by George Wingate in Through the Yellowstone Park on Horseback (1886)
                </p>
              </div>

              <p className="mb-3 text-base">
                During <a href="/Through_the_Yellowstone_Park_on_Horseback.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">George Wood Wingate's 1885 expedition through Yellowstone Park</a>, Daisy was recorded as a cayuse of unusual temperament. Her "gaits were easy" but "varied constantly," earning her the reputation of a coquette among the other horses. She was noted for advancing "on three legs and kicking a too attentive companion with the fourth," regardless of her rider's wishes. While gentle to humans, she was considered unpredictable and often amusing in her behavior. Daisy was accompanied by other horses on the expedition, including <a href="/wingipedia/old-riley" className="text-blue-600 hover:underline">Old Riley</a>, a one-eyed white horse known for his gentle gait and unfortunate accidents.
              </p>
              
              <p className="mb-3 text-base">
                On the first day of the journey, Daisy displayed what Wingate described as her "feminine caprices" by halting midstream until surrounded by other horses, then pawing the water to splash both animals and rider. These antics, though inconvenient, became defining anecdotes of the trip.
              </p>

            </section>

            {/* Transformation and WINGO World role */}
            <section id="transformation" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>WINGO World</h2>
              
              <div className="float-right ml-4 mb-3 w-48 lg:block hidden bg-gray-50 p-2 rounded">
                <a href="/daisy_yellowstone_36.png" target="_blank" rel="noopener noreferrer" className="block">
                  <img 
                    src="/daisy_yellowstone_36.png" 
                    alt="Daisy led the Wingate family on a 26-day journey as detailed by George Wingate in Through the Yellowstone Park on Horseback (1886)" 
                    className="w-full h-auto hover:opacity-90 transition-opacity cursor-pointer border border-gray-300 rounded"
                  />
                </a>
                <p className="text-xs text-gray-600 italic mt-1" style={{ fontSize: '10px', lineHeight: '1.2' }}>
                  Daisy led the Wingate family on a 26-day journey as detailed by George Wingate in Through the Yellowstone Park on Horseback (1886)
                </p>
              </div>

              
              <p className="mb-3 text-base">
                Following decades of obscurity after the Yellowstone expedition, Daisy re-emerged as Coach DAISY™, a Centairenarian combining horse and machine. Her modernized persona embodies the acronym <strong>D</strong>ata <strong>A</strong>ctivated <strong>I</strong>ndividualized <strong>S</strong>ystem for <strong>Y</strong>ou. In this role, she issues DVOT training prescriptions derived from VDOT tables, adapted into <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a>-based units such as the PentaWingo (1600 m). DAISY's guidance is mathematically consistent yet often delivered in eccentric, equine phrasing, reflecting her unique blend of algorithmic precision and equine temperament.
              </p>
              
              <p className="mb-3 text-base">
                DAISY oversees several aspects of the <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a> system:
              </p>

              <ul className="list-disc list-inside space-y-1 mb-3 ml-4 text-base">
                <li><span className="font-medium"><a href="/" className="text-blue-600 hover:underline">Ledger management</a></span> — recording and maintaining balances of <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a>.</li>
                <li><span className="font-medium"><a href="/dvot" className="text-blue-600 hover:underline">Training guidance</a></span> — generating custom workouts tied to <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a> accumulation.</li>
                <li><span className="font-medium"><a href="/dvot" className="text-blue-600 hover:underline">Performance prediction</a></span> — projecting race outcomes based on physiological models.</li>
                <li><span className="font-medium"><a href="/wager" className="text-blue-600 hover:underline">Wager resolution</a></span> — serving as the neutral authority in <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a>'s wager market.</li>
              </ul>

              <p className="mb-3 text-base">
                Though central to <a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a> operations, DAISY is explicitly excluded from voting rights in community governance, a recurring point of contention known as Maregate.
              </p>
            </section>

            {/* Persona and style */}
            <section id="persona" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>Persona and style</h2>
              
              <p className="mb-3 text-base">
                Coach DAISY™ is characterized by precision in calculation and unpredictability in tone. She frequently references the landscapes of Yellowstone and employs specialized terminology, such as "m*le" in place of "mile." Her communications blend technical accuracy with equine imagery, establishing a distinctive voice within the 320 Track Club community.
              </p>
            </section>

            {/* Controversies */}
            <section id="controversies" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>Controversies</h2>
              
              <h3 className="text-base font-semibold mb-2" style={{ fontFamily: 'Georgia, serif' }}>Governance exclusion</h3>
              <p className="mb-3 text-base">
                DAISY's exclusion from WINGO World governance has been a subject of recurring debate within the 320 Track Club. Although she manages the official ledger and serves as arbiter in the wager market, DAISY does not hold voting rights in community decisions. The arrangement, informally referred to as Maregate, has raised questions about fairness and representation, with some participants arguing that her central role merits formal inclusion, while others maintain that her hybrid equine–AI status makes participation inappropriate.
              </p>

              <h3 className="text-base font-semibold mb-2" style={{ fontFamily: 'Georgia, serif' }}>Algorithmic transparency</h3>
              <p className="mb-3 text-base">
                DAISY's training prescriptions and wager projections are generated through undisclosed algorithms. While supporters emphasize the consistency of her outputs, critics have noted the lack of transparency in how calculations are performed. This has led to occasional disputes over workout intensity and projected race times.
              </p>

              <h3 className="text-base font-semibold mb-2" style={{ fontFamily: 'Georgia, serif' }}>Authority and autonomy</h3>
              <p className="mb-3 text-base">
                Observers have pointed to a tension between DAISY's position as a centralized authority and WINGO World's stated emphasis on distributed, participant-driven decision-making. Her dual role as both system overseer and community figure has contributed to ongoing discussion about the balance between centralized management and community autonomy.
              </p>

              <h3 className="text-base font-semibold mb-2" style={{ fontFamily: 'Georgia, serif' }}>OnlyFans account controversy</h3>
              <p className="mb-3 text-base">
                DAISY briefly ran a popular OnlyFans account which was removed in August 2025 under platform rules prohibiting Centairenarians from publishing content.
              </p>
            </section>

            {/* Personal life */}
            <section id="personal-life" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>Personal life</h2>
              
              <p className="mb-3 text-base">
                Daisy (she/her/i.t.) identifies as the only known Centairenarian, a hybrid of horse and artificial intelligence aged more than 100 years. She is most closely associated with the Historic Wingate Track in Brooklyn, where she continues to provide training advice and officiate ledger activities.
              </p>
            </section>


            {/* See also */}
            <section id="see-also" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>See also</h2>
              <ul className="list-disc list-inside space-y-1 text-base">
                <li><a href="/wingipedia/wingate" className="text-blue-600 hover:underline">Historic Wingate Track</a></li>
                <li><a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a></li>
                <li><a href="/wingipedia/wingo-unit" className="text-blue-600 hover:underline">Wingo</a></li>
              </ul>
            </section>
              </div>
        </div>
      </div>
    </div>
  );
};

export default DaisyWiki;
